import React, { Component } from 'react';
import Input from '../component/Input.js';

export default class CreateTiers extends Component {
	constructor(props){
		super(props);
		this.state = {tier:'',points:'',index:this.props.id};
		this.handleInput = this.handleInput.bind(this);
	}
	
	handleInput(identity,value){ //standard method for handling user input, with added regex to only allow numbers
		if(/^(\s*|[1-9][0-9]*)$/.test(value)){
			const theState = {};
			theState[identity] = value;
			this.setState(theState);
		}
	}

	componentDidUpdate(prevProps){ 
		if(this.props.save){ //if the user has clicked the save button
			let tID = this.props.id.toString()+'_tier'; //tier id
			let pID = this.props.id.toString()+'_points'; //points/price id
			if(prevProps.save === false && this.props.save === true && this.state.tier !== '' && this.state.points !== ''){ //conditional to prevent infinite loop and to check whether or not values have been entered for the tier and points/price field
				this.props.onSave(this.state); //pass up tier info to parent (ManageTiers)
			}else if(prevProps.save === false && this.props.save === true &&  (this.state.tier === '' && this.state.points !== '') || (this.state.tier !== '' && this.state.points === '')){ //if one or both of the fields is blank
				if(this.state.points !== '' && this.state.tier === ''){ //highlight tier input
					document.getElementById(tID).style.borderColor="red";
				}else{
					document.getElementById(tID).style.borderColor="inherit";
				}
				if(this.state.points === '' && this.state.tier !== ''){ //highlight points/price input
					document.getElementById(pID).style.borderColor="red";
				}else{
					document.getElementById(pID).style.borderColor="inherit";
				}
				this.props.onSave(this.state); //pass up incomplete information so that parent can display proper error message
			}else if(prevProps.save === false && this.props.save === true && this.state.tier === '' && this.state.points === ''){ //once state has been passed up, remove error highlighting
				document.getElementById(tID).style.borderColor="inherit";
				document.getElementById(pID).style.borderColor="inherit";
			}
		}
		if(this.props.success){ //if success, clear inputs
			if(prevProps.success !== this.props.success && this.props.success){
				this.setState({tier:'',points:''});
			}
		}
	}

	render(){
		const inputStyles = "h2 br2 bw1 w-100 shadow-3 pl2 pr2";
		let label;
		if(this.props.app === "lov"){ //tiers have point values for lov, have price values for asm
			label = "Points: ";
		}else{
			label = "Price: ($)";
		}
		let tierId = this.props.id.toString()+'_tier';
		let pointsId = this.props.id.toString()+'_points';
		return(
			<div className="w-90-ns w-100-m w-100 center" style={{maxWidth:'500px',margin:'auto'}}>
				<div className="fl w-50 mb3 pr3">
					<div className="fl w-100 mt2 navy">
						<label className="b navy">Tier Number: </label>
					</div>
					<div className="fl w-100">
						<Input identity="tier" id={tierId} onInput={this.handleInput} type="number" val={this.state.tier} inputStyle={inputStyles}/>
					</div>
				</div>
				<div className="fl w-50 mb3">
					<div className="fl w-100 mt2 navy">
						<label className="b navy">{label}</label>
					</div>
					<div className="fl w-100">
						<Input identity="points" id={pointsId} onInput={this.handleInput} type="number" val={this.state.points} inputStyle={inputStyles}/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CreateTiers.js